import { PipelineCustomizationReturnType } from '@flowwai-frontend/bps-officer-web/iam'
import {
   PipelineModel,
   UserAttendance,
   UserAttendanceStatus,
   UserModel
} from '@flowwai-frontend/shared/sales-crm/sales-crm-core'
import { ALL_AGENTS_ID } from '../constants/CallLogsConstants'

//TODO: need to move to common util
export const getAgentDetailsWithYouOption = (
   agentDetails: UserModel,
   youPrefix: string
): UserModel => {
   const userDetailsWithYouPrefix: UserModel = Object.assign(
      Object.create(Object.getPrototypeOf(agentDetails)),
      agentDetails
   )
   const userNameWithYou = `${userDetailsWithYouPrefix.name} ${youPrefix}`
   userDetailsWithYouPrefix.setName(userNameWithYou)

   return userDetailsWithYouPrefix
}

export const getCallLogsPipelines = (
   pipelines: Array<PipelineModel>,
   getPipelineCustomizations: (
      pipelineId: string
   ) => PipelineCustomizationReturnType
): Array<PipelineModel> => {
   const filteredPipelines: Array<PipelineModel> = []

   pipelines.forEach(pipeline => {
      const { isCallLogsEnabled } = getPipelineCustomizations(
         pipeline.pipelineId
      )

      if (isCallLogsEnabled) {
         filteredPipelines.push(pipeline)
      }
   })

   return filteredPipelines
}

export const getCallLogAgentActiveStatus = (
   agentId: string | undefined,
   attendance: UserAttendance | null | undefined,
   getAttendanceStatusFromObj: (userObj: {
      attendance?: UserAttendance | null
   }) => UserAttendanceStatus | null
): UserAttendanceStatus | null => {
   const isAllAgentsSelected = agentId === ALL_AGENTS_ID
   return isAllAgentsSelected
      ? null
      : getAttendanceStatusFromObj({ attendance })
}
